import React from "react";
import { formatBalance } from "../Utils/numberFormatter";


const Header = ({ title, balance, rightContent }) => {


  return (
    <div className="sticky top-1 z-50 bg-main1 text-light rounded-2xl px-6 py-3 flex items-center justify-between shadow-md m-1">
      {/* العنوان (يسار) */}
      <h1 className="text-xl font-bold">{title}</h1>

      {/* الرصيد + الزر (يمين) */}
      <div className="flex items-center gap-4">
        {balance !== undefined && balance !== null && balance !== "" && (
          <div className="bg-light text-main1 px-4 py-1.5 rounded-full font-medium shadow-sm flex items-baseline gap-2">
            <span className="text-main1">رصيدك  :</span>
            <span className="text-main2 font-bold flex items-baseline gap-1  flex-row-reverse">
              <span>{formatBalance(balance)}</span>
              <small className="text-xs">ليرة سورية</small>
            </span>
          </div>
        )}
        {rightContent}
      </div>
    </div>
  );
};

export default Header;


























